export const iconFontAwesomeSpinnersArrowRotateRight = (
	<i className="fa-solid fa-arrow-rotate-right"></i>
);
